<template>
<div id="safe-manager">
  <div class="wrapper">
    <mainHeader class="mainHeader"></mainHeader>
    <img v-for="(value, index) in images" :key="index" v-bind:src="value" />
    <mainFooter class="mainFooter"></mainFooter>
  </div>
</div>
</template>
<script>
import mainHeader from '../view/header'
import mainFooter from '../view/footer'

export default{
  data () {
    return {
      images: [
        require('../assets/icon-pro1.jpg'),
        require('../assets/icon-pro2.jpg'),
        require('../assets/icon-pro3.jpg')]
    }
  },
  methods: {
    applyClick: function () {

    }
  },
  components: { // 注册组件
    mainHeader,
    mainFooter
  }
}
</script>

<style scoped>
.wrapper{
  background-color: #F6F6F6;
  width: 100%;
}
.mainHeader{
  position: fixed;
  top: 0px;
  height: 55px;
  width: 100%;
}
img{
  width: 100%;
  display: block;
}
img:first-of-type{
  margin-top: 55px;
}
.mainFooter{
}
</style>



// WEBPACK FOOTER //
// src/view/product-testing.vue